import type { NodeViewProps } from "@tiptap/react";
import { NodeViewWrapper } from "@tiptap/react";
import {
  MentionComponentAttributeNames,
  type TMentionComponentAttributes
} from "./types";
import type { MentionExtensionOptions } from "./extention-config";

export type MentionNodeViewProps = NodeViewProps & {
  node: NodeViewProps["node"] & {
    attrs: TMentionComponentAttributes;
  };
};

export const MentionNodeView = (props: MentionNodeViewProps) => {
  const {
    extension,
    node: { attrs }
  } = props;

  return (
    <NodeViewWrapper className="mention-component inline w-fit">
      {(extension.options as MentionExtensionOptions).renderComponent({
        entity_identifier:
          attrs[MentionComponentAttributeNames.EntityIdentifier] ?? "",
        entity_name:
          attrs[MentionComponentAttributeNames.EntityName] ?? "partner_user"
      })}
    </NodeViewWrapper>
  );
};
